/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUnitType = 0 | 1;

export const EUnitType = {
    NUMBER_0: 0 as EUnitType,
    NUMBER_1: 1 as EUnitType
};

